import React, { Component } from 'react';
import Button from '@material-ui/core/Button';
import PropTypes from 'prop-types';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import NavigationIcon from '@material-ui/icons/Navigation';
import { withStyles, useTheme } from '@material-ui/core/styles';
import { relativeTimeRounding } from 'moment';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { DialogContentText, DialogActions } from '@material-ui/core';


const QRCode = require('qrcode.react');

const routeLink = (props) => {
  const { companyName, street, zip, city } = props.order.address;
  return `https://www.google.com/maps/dir/?api=1&destination=${companyName || ''}+${street}+${zip}+${city}&force_app_breakout=1`;
};

function renderRouting(props) {
  const { classes } = props;

  return (
    <div className={classes.routeactionsContainer}>
      <QRCode
        value={routeLink(props)}
        renderAs="svg"
      />
      <br />
      <br />
    </div>
  );
}

function renderActions(props) {
  const { order, onClose, classes } = props;
  if (!order) {
    return null;
  }

  const { address } = order;
  const backButton = (
    <Button
      color="primary"
      onClick={onClose}
    >
      Zurück
    </Button>
  );

  if (!address) {
    return backButton;
  }

  return (
    <>
      {backButton}
      <a className={classes.link} href={routeLink(props)} target="_blank">
        <Button
          color="primary"
          onClick={() => { onClose(); }}
        >
          Maps öffnen
        </Button>
      </a>
    </>
  );
}

function renderContent(props) {
  const { order } = props;

  if (!order) {
    return null;
  }

  const { address } = order;

  if (!address) {
    return (
      <div>
        <p>Keine Adresse verfügbar.</p>
      </div>
    );
  }

  return (
    <div>
      <strong>{order.pickupName}</strong>
      <br />
      <strong>{address.companyName}</strong><br />
      <span>{address.street}</span><br />
      <span>{address.zip} {address.city}</span><br />
      <span>Stiege: {address.stairway || '-'} / Stock: {address.floor || '-'} / Tür: {address.door || '-'}</span>

      <p>Telefon: <a href={`tel:${address.telephone}`}>{address.telephone}</a></p>
      {renderRouting(props)}
    </div>
  );
}


function DeliveryDialog(props) {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('xs'));

  return (
    <Dialog
      classes={{ paper: 'printDialog' }}
      open={props.open}
      fullScreen={fullScreen}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">Lieferung</DialogTitle>
      <DialogContent>
        <DialogContentText>
          {renderContent(props)}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        {renderActions(props)}
      </DialogActions>
    </Dialog>
  );
}

const styles = theme => ({
  actionContainer: {
    display: 'flex',
    justifyContent: 'center',
  },
  routeactionsContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    flexGrow: 1,
    padding: '2px',
    minWidth: '300px',
  },
  link: {
    textDecoration: 'none',
  },
});


DeliveryDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  open: PropTypes.bool.isRequired,
  order: PropTypes.object,
  onClose: PropTypes.func.isRequired,
};

DeliveryDialog.defaultProps = {
  order: null,
};


export default withStyles(styles)(DeliveryDialog);

